import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { firmwareStat } from "../../actions/stat";
import { setPeriod } from "../../reducers/statReducer";
import { firmwareData } from "../../settings/firmware";

import "./admiinStat.css";

export default function AdminStat() {
  const currentStat = useSelector((state) => state.stat.stat);
  const currentPeriod = useSelector((state) => state.stat.period);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(firmwareStat());
  }, [dispatch]);

  const getClicksCount = (id) => {
    if (currentPeriod === 0) {
      // All time
      const item = currentStat.find((el, i) => {
        if (el.title === id) {
          return true;
        } else {
          return false;
        }
      });
      if (!item) {
        return 0;
      }
      return item.count;
    }
    if (currentPeriod === 1) {
      // Month
      const item = currentStat.find((el, i) => {
        if (el.title === id) {
          return true;
        } else {
          return false;
        }
      });
      if (!item) {
        return 0;
      }
      let d = new Date();
      d.setMonth(d.getMonth() - 1);
      const period = item.past.find((el, i) => {
        if (new Date(el.date) - d > 0) {
          return true;
        } else {
          return false;
        }
      });
      if (!period) {
        return 0;
      } else {
        return item.count - period.count;
      }
    }
    if (currentPeriod === 2) {
      // Week
      const item = currentStat.find((el, i) => {
        if (el.title === id) {
          return true;
        } else {
          return false;
        }
      });
      if (!item) {
        return 0;
      }
      let d = new Date();
      d.setDate(d.getDate() - 7);
      const period = item.past.find((el, i) => {
        if (new Date(el.date) - d > 0) {
          return true;
        } else {
          return false;
        }
      });
      if (!period) {
        return 0;
      } else {
        return item.count - period.count;
      }
    }
    if (currentPeriod === 3) {
      // Week
      const item = currentStat.find((el, i) => {
        if (el.title === id) {
          return true;
        } else {
          return false;
        }
      });
      if (!item) {
        return 0;
      }
      let d = new Date();
      d.setDate(d.getDate() - 1);
      const period = item.past.find((el, i) => {
        if (new Date(el.date) - d > 0) {
          return true;
        } else {
          return false;
        }
      });
      if (!period) {
        return 0;
      } else {
        return item.count - period.count;
      }
    }
  };

  const getAllClicksCount = (id) => {
    let arr = currentStat.filter((el, i) => {
      if (el.title.includes(id)) {
        return true;
      } else {
        return false;
      }
    });
    if (currentPeriod === 0) {
      if (arr.length < 1) {
        return 0;
      } else {
        let r = 0;
        arr.forEach((element) => {
          r += element.count;
        });
        return r;
      }
    }
    if (currentPeriod === 1) {
      if (arr.length < 1) {
        return 0;
      } else {
        let r = 0;
        let d = new Date();
        d.setMonth(d.getMonth() - 1);
        arr.forEach((element) => {
          const period = element.past.find((el, i) => {
            if (new Date(el.date) - d > 0) {
              return true;
            } else {
              return false;
            }
          });
          if (period) {
            r += element.count - period.count;
          }
        });
        return r;
      }
    }
    if (currentPeriod === 2) {
      if (arr.length < 1) {
        return 0;
      } else {
        let r = 0;
        let d = new Date();
        d.setDate(d.getDate() - 7);
        arr.forEach((element) => {
          const period = element.past.find((el, i) => {
            if (new Date(el.date) - d > 0) {
              return true;
            } else {
              return false;
            }
          });
          if (period) {
            r += element.count - period.count;
          }
        });
        return r;
      }
    }
    if (currentPeriod === 3) {
      if (arr.length < 1) {
        return 0;
      } else {
        let r = 0;
        let d = new Date();
        d.setDate(d.getDate() - 1);
        arr.forEach((element) => {
          const period = element.past.find((el, i) => {
            if (new Date(el.date) - d > 0) {
              return true;
            } else {
              return false;
            }
          });
          if (period) {
            r += element.count - period.count;
          }
        });
        return r;
      }
    }
  };

  const renderList = (arr = []) => {
    return arr.map((el, i) => (
      <tr className="adminStatTableRow" key={i}>
        <td className="text-left">{el.title}</td>
        <td className="adminStatTextCenter">{getClicksCount(el.statistic)}</td>
      </tr>
    ));
  };

  const renderTotal = (keys = []) => {
    return (
      <tr className="adminStatTableRow selected">
        <td className="text-left">Всего:</td>
        <td className="adminStatTextCenter">
          {keys.map((key) => getAllClicksCount(key)).reduce((a, b) => a + b, 0)}
        </td>
      </tr>
    );
  };

  const renderTable = (title = "", arr, keys, className = []) => {
    return (
      <div className={["adminStatTableContainer", ...className].join(" ")}>
        <h1>{title}</h1>
        <table className="adminStatTable">
          <thead>
            <tr>
              <th className="text-left">Имя</th>
              <th className="adminStatTextCenter clickable">
                Количество кликов
              </th>
            </tr>
          </thead>
          <tbody>
            {renderList(arr)}
            {renderTotal(keys)}
          </tbody>
        </table>
      </div>
    );
  };

  return (
    <div>
      <div className="adminStatPeriodContainer">
        <div
          className={
            currentPeriod === 0
              ? "adminStatPeriodButton active"
              : "adminStatPeriodButton"
          }
          onClick={() => currentPeriod !== 0 && dispatch(setPeriod(0))}
        >
          За все время
        </div>
        <div
          className={
            currentPeriod === 1
              ? "adminStatPeriodButton active"
              : "adminStatPeriodButton"
          }
          onClick={() => currentPeriod !== 1 && dispatch(setPeriod(1))}
        >
          За последний месяц
        </div>
        <div
          className={
            currentPeriod === 2
              ? "adminStatPeriodButton active"
              : "adminStatPeriodButton"
          }
          onClick={() => currentPeriod !== 2 && dispatch(setPeriod(2))}
        >
          За последнюю неделю
        </div>
        <div
          className={
            currentPeriod === 3
              ? "adminStatPeriodButton active"
              : "adminStatPeriodButton"
          }
          onClick={() => currentPeriod !== 3 && dispatch(setPeriod(3))}
        >
          За сегодня
        </div>
      </div>
      <div className="adminStatTablesWrapper">
        <div className="adminStatTableContainer">
          {renderTable(
            "IMG",
            firmwareData.seventeenth.firmware,
            [firmwareData.seventeenth.statisticKey],
            ["child"]
          )}
          {renderTable(
            "HIVE ON",
            firmwareData.hiveon.firmware,
            [firmwareData.hiveon.statisticKey],
            ["child", "margin-top-2vw"]
          )}
        </div>
        {renderTable(
          "TAR",
          firmwareData.tar.firmwareA.concat(
            firmwareData.tar.firmwareB,
            firmwareData.custom.firmware
          ),
          [firmwareData.tar.statisticKey, firmwareData.custom.statisticKey]
        )}
        <div className="adminStatTableContainer">
          {renderTable(
            "VNISH",
            firmwareData.vnish.firmware,
            [firmwareData.vnish.statisticKey],
            ["child"]
          )}
          {renderTable(
            "19я серия",
            firmwareData.nineteenth.firmwareA.concat(
              firmwareData.nineteenth.firmwareB
            ),
            [firmwareData.nineteenth.statisticKey],
            ["child", "margin-top-2vw"]
          )}
        </div>
      </div>
      <div className="adminStatAllStatContainer">
        <div className="adminStatAllStat">
          Всего кликов:{" "}
          <span>
            {Object.keys(firmwareData)
              .map((key) => getAllClicksCount(firmwareData[key].statisticKey))
              .reduce((a, b) => a + b, 0)}
          </span>
        </div>
      </div>
    </div>
  );
}
